<div class="modal-content flex flex-row">
  <ion-button class="close" fill="clear" shape="round" (click)="close()">
    <ion-icon name="close-outline"></ion-icon>
  </ion-button>

  <div *ngIf="productSelected$ | async; let product" class="product-container flex flex-row items-stretch gap-5">
    <div class="flex w-1/2 flex-col">
      <img
        *ngIf="product.subType !== ProductSubType.CUSTOM"
        [src]="MediaFile.addNameSuffix(product.pictureUrl, 'm')"
        class="img-product"
      />
      <ng-container *ngIf="product.subType === ProductSubType.CUSTOM">
        <app-notebook-preview
          *ngIf="product.customType === 'notebook'"
          [optionsSelected]="optionsSelected"
        ></app-notebook-preview>
      </ng-container>
    </div>
    <div class="flex flex-1 flex-col justify-between">
      <app-product-part-info-interaction
        [product]="product"
        [isSummary]="true"
        [variantSelected$]="variantSelected$"
        [measurement]="measurement"
        [highestDiscount]="highestDiscount"
        (action)="onAction($event)"
      ></app-product-part-info-interaction>
    </div>
  </div>
</div>
